import React from "react";
import './customButton.style.scss';

const CustomButton = ({ background, label, onClick, textColor, icon, isSelected, toolTip, variant }) => {
    // Determine dynamic classes based on props
    const buttonClasses = `custom-button ${variant === "outline" ? "outline" : ""} ${isSelected ? "selected" : ""}`;

    return (
        <button
            title={toolTip}
            className={buttonClasses}
            onClick={onClick}
            style={{
                "--button-bg": background || "var(--primary)",
                "--text-color": textColor || "var(--white)",
            }}
        >
            {icon ? (
                <>
                    <img
                        src={icon}
                        alt=""
                        aria-hidden="true"
                        style={{
                            height: "18px",
                            width: "18px",
                        }}
                    />
                    {label && <span>{label}</span>}
                </>
            ) : (
                label
            )}
        </button>
    );
};

export default CustomButton;
